import './OrderCountry.scss';

/**
 * Skeleton loader para el componente OrderCountry
 * @param countryName - Nombre del país para mantener el header mientras carga el contenido
 * @param flag - URL de la bandera del país
 * @param exchangeRate - Tasa de cambio del país
 * @param currency - Moneda del país
 * @param isLast - Indica si es el último país en la lista
 */
const OrderCountrySkeleton = ({
  countryName,
  flag,
  exchangeRate,
  currency,
  isLast
}: {
  countryName: string;
  flag?: string | null;
  exchangeRate?: string | null;
  currency?: string | null;
  isLast?: boolean;
}) => {
  return (
    <div className="orderCountry">
      <div className="countryHeader">
        <div className="countryFlag" style={{ backgroundImage: `url(${flag || ''})` }} />
        <div className="countryName">{countryName}</div>
        <div className="countryExchangeRate">
          Tasa de cambio: {exchangeRate}
          {currency}
        </div>
      </div>
      <div className="referencesList animate-pulse">
        {/* Simulamos 2 referencias por país */}
        {[1, 2].map((_, i) => (
          <div key={i} className="mb-16 bg-white rounded-lg shadow">
            <div className="p-16">
              {/* Header de la referencia */}
              <div className="flex items-center gap-16 mb-16">
                <div className="h-32 bg-gray-200 rounded w-96" />
                <div className="h-32 bg-gray-200 rounded w-128" />
              </div>
              
              {/* Detalles de la referencia */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-16 mb-16">
                <div className="h-16 bg-gray-200 rounded" />
                <div className="h-16 bg-gray-200 rounded" />
                <div className="h-16 bg-gray-200 rounded" />
                <div className="h-16 bg-gray-200 rounded" />
              </div>

              {/* Lista de items */}
              <div className="mt-24">
                {[1, 2].map((_, j) => (
                  <div key={j} className="mb-12 p-12 border border-gray-200 rounded">
                    <div className="grid grid-cols-3 gap-16">
                      <div className="h-16 bg-gray-200 rounded" />
                      <div className="h-16 bg-gray-200 rounded" />
                      <div className="h-16 bg-gray-200 rounded" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {!isLast && <div className="grayLine" />}
    </div>
  );
};

export default OrderCountrySkeleton;
